<template>
  <div>
    <!-- 待绑定管理番号 -->
    <div class="operation">
      <div class="search">
        <!-- 客户ID -->
        <div class="item">
          <el-input clearable v-model="datas.user_id" :placeholder="$t('message.userID')"
            @blur="setDefaultValue"></el-input>
        </div>
        <!-- 店铺ID -->
        <div class="item">
          <el-input clearable v-model="datas.shop_id" :placeholder="$t('message.shopID')"></el-input>
        </div>
        <!-- 店铺名 -->
        <div class="item">
          <el-input clearable v-model="datas.shop_name" :placeholder="$t('message.shopName')"></el-input>
        </div>
        <!-- 商品ID -->
        <div class="item">
          <el-input clearable v-model="datas.goods_id" :placeholder="$t('message.goodsID')"></el-input>
        </div>
        <!-- 订单号 -->
        <div class="item">
          <el-input clearable v-model="datas.order_sn" :placeholder="$t('message.orderNumber')"></el-input>
        </div>
        <!-- 搜索 -->
        <el-button type="primary" @click="search">{{ $t('message.search') }}</el-button>
        <!-- 重置 -->
        <el-button @click="reset">{{ $t('message.reset') }}</el-button>
        <!-- 系统上一次生成的管理番号 -->
        <div class="mash">
          <!--生成系统管理番号  -->
          <span style="margin-right: 10px;"> {{ skuCode }}</span>
          <el-button type="primary" @click="randClientSkuCode">{{ $t('message.creationManagementDesignation')
          }}</el-button>
          <el-popover placement="top" width="300" trigger="hover"
            content="点击按钮生成公司统一格式的管理番号，用于给没有自己管理番号的客户管理商品，管理番号生成后，会自动复制到粘贴板，可直接给客户进行商品分组">
            <i class="el-icon-question" slot="reference"></i>
          </el-popover>
        </div>
      </div>
      <!-- 按钮区域 -->
      <div class="btn">
        <!-- EXCEL批量绑定 -->
        <el-button type="primary" class="primary" @click="$message.error('暂未开放')">{{ $t('message.batchBindingOfEXCEL')
        }}</el-button>
        <!-- 批量设置管理番号 -->
        <el-button type="primary" class="primary" @click="batchSetManagementNumber">{{
          $t('message.batchSetManagementNumber') }}</el-button>
      </div>
    </div>
    <!-- 列表 -->
    <div class="table">
      <ol>
        <li class="flex05">
          <el-checkbox v-model="checked" @change="allChecked"></el-checkbox>
        </li>
        <!--管理番号  -->
        <li>{{ $t('message.managementDesignation') }}</li>
        <!--客户信息  -->
        <li>{{ $t('message.userInfo') }}</li>
        <!--工厂  -->
        <li class="flex2">{{ $t('message.factory') }}</li>
        <!--商品链接  -->
        <li class="flex2">{{ $t('message.ProductLink') }}</li>
        <!--商品图片  -->
        <li>{{ $t('message.productPicture') }}</li>
        <!--SKU  -->
        <li>SKU</li>
        <!--状态  -->
        <li>{{ $t('message.status') }}</li>
        <!--关联订单  -->
        <li class="flex2">{{ $t('message.relatedOrders') }}</li>
        <!--操作  -->
        <li class="flex05">{{ $t('message.operation') }}</li>
      </ol>
      <ul v-for="(item, index) in tableData" :key="index">
        <li class="flex05">
          <el-checkbox v-model="item.checked" @change="isAll"></el-checkbox>
        </li>
        <!--管理番号  -->
        <li>
          <el-input type="textarea" v-model="item.client_sku_code" @blur="updateClientCode(item, 'single')"></el-input>
        </li>
        <!--客户信息  -->
        <li>
          <div>
            <p>{{ item.user.realname }}</p>
            <p>ID:{{ item.user.id }}</p>
          </div>
        </li>
        <!--工厂  -->
        <li class="flex2">{{ item.item_sku.item.shop_name }}</li>
        <!--商品链接  -->
        <li class="flex2"> <a :href="item.goods_url.goods_url" rel="noopener noreferrer" target="_blank"
            class="word-break">{{
              item.goods_url.goods_url
            }}</a> </li>
        <!--商品图片  -->
        <li>
          <el-image style="width: 70px;height: 70px;border-radius: 6px;" :src="item.pic" :preview-src-list="[item.pic]">
          </el-image>
        </li>
        <!--SKU  -->
        <li>
          <div>
            <p v-for="(detail, indexs) in item.item_sku.detail" :key="indexs">{{ detail.key }}:{{ detail.value }}</p>
          </div>
        </li>
        <!--状态  -->
        <li></li>
        <!--关联订单  -->
        <li class="flex2">
          <div>
            <p v-for="(order) in item.order_sn_arr" :key="order">
              <router-link :to="'/orderDetail?order_sn=' + order" target="_blank">
                {{ order }}
              </router-link>
            </p>
          </div>
        </li>
        <!--操作  -->
        <li class="flex05">
          <!-- 删除 -->
          <el-button type="text" @click="tmpHide(item, 'single')">{{ $t('message.delete') }}</el-button>
        </li>
      </ul>
    </div>
    <!-- 分页 -->
    <div class="pagination">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
        :page-sizes="[10, 20, 30, 40]" :page-size="datas.pageSize" layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 管理番号 -->
    <el-dialog :title="$t('message.managementDesignation')" :close-on-click-modal="false"
      :visible.sync="codeDialogVisible" width="488px" center>
      <div style="padding: 0 20px;">
        <el-input v-model="client_sku_code" onfocus="this.select()" type="textarea"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- 保存 -->
        <el-button type="primary" @click="updateClientCode({ client_sku_code }, 'all')">{{
          $t("message.save")
        }}</el-button>
      </span>
    </el-dialog>
    <!-- EXCEL一键导入 -->
    <el-dialog :title="$t('message.excelOneClickImport')" :close-on-click-modal="false"
      :visible.sync="EXCELDialogVisible" width="600px" center>
      <div style="padding: 0 20px;" class="excelOneClickImport">
        <div class="EXCELtext">
          1、请先点击右边下载，下载当前待编辑的表格数据，在进行商品编辑，编辑完成在进行上传 <i class="el-icon-upload"></i>
        </div>
        ２、请选择上传文件。
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="EXCELDialogVisible = false">{{
          $t("message.cancel")
        }}</el-button>
        <!-- 导入 -->
        <el-button type="primary" @click="updateClientCode({ client_sku_code }, 'all')">{{
          $t("message.import")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      checked: false,
      checked1: false,
      checked2: false,
      datas: {
        user_id: localStorage.getItem('product_user_id') ? localStorage.getItem('product_user_id') : '',
        shop_id: '',
        shop_name: '',
        goods_id: '',
        page: 1,
        pageSize: 10,
      },
      tableData: [],
      multipleSelection: [],
      total: 0,
      // 批量管理番号
      codeDialogVisible: false,
      client_sku_code: '',
      // EXCEL一键导入
      EXCELDialogVisible: false,
      skuCode: localStorage.getItem('skuCode')
    };
  },
  created() {
    if (this.$route.query.product_user_id) {
      this.datas.user_id = this.$route.query.product_user_id
    }
     if (this.$route.query.order_sn) {
      this.datas.order_sn = this.$route.query.order_sn
    }
    
    this.productTmpList()
  },
  methods: {
    search() {
      this.datas.page = 1
      this.productTmpList()
    },
    // 全选
    allChecked() {
      this.multipleSelection = []
      this.tableData.forEach(item => {
        item.checked = this.checked
        if (item.checked) {
          this.multipleSelection.push(item)
        }
      })
    },
    // 检查是否全选
    isAll() {
      this.multipleSelection = []
      this.tableData.forEach(item => {
        if (item.checked) {
          this.multipleSelection.push(item)
        }
      })
      this.checked = this.tableData.every(item => item.checked)
    },
    reset() {
      this.datas = {
        user_id: '',
        shop_id: '',
        shop_name: '',
        goods_id: '',
        order_sn: '',
        page: 1,
        pageSize: 10,
      }
      this.setDefaultValue()
      this.productTmpList()
    },
    // 无需维护列表
    productTmpList() {
      this.$api.productManagementApi.productTmpList(this.datas).then(res => {
        res.data.data.forEach(item => {
          item.checked = false
        })
        this.tableData = res.data.data
        this.total = res.data.total
      })
    },
    //更新页数
    handleCurrentChange(val) {
      this.datas.page = val;
      this.productTmpList();
    },
    //更新分页每页数量
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.productTmpList();
    },
    // 删除
    tmpHide(data) {
      let datas = {
        user_id: data.user_id,
        ids: [data.id],
      }
      this.$confirm('请确认选中的商品是否后续不需要跟进与维护保存后，确认后，该商品将默认进行过滤。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.$api.productManagementApi.tmpHide(datas).then(res => {
          this.$message.success(res.msg)
          this.productTmpList()
        })
      }).catch(() => {

      });
    },
    // 批量设置管理番号
    batchSetManagementNumber() {
      if (this.multipleSelection == false) return this.$message.error('未选择要操作的数据')
      this.client_sku_code = ''
      this.codeDialogVisible = true
    },
    //待补全列表-填写番号
    updateClientCode(data, type) {
      let datas = {
        client_sku_code: data.client_sku_code,
        ids: [],
      }
      if (type == 'single') {
        datas = {
          client_sku_code: data.client_sku_code,
          ids: [data.id],
          user_id: data.user_id
        }
      } else {
        this.multipleSelection.forEach(item => {
          datas.ids.push(item.id)
        })
      }
      this.$confirm('请确认选中的商品对应的商品管理番号是否正确，保存后，该商品将纳入历史数据统计范围。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.$api.productManagementApi.updateClientCode(datas).then(res => {
          this.$message.success(res.msg)
          this.productTmpList()
          this.codeDialogVisible = false
        })
      }).catch(() => {

      });
    },
    //生成默认管理番号
    randClientSkuCode() {
      this.$api.productManagementApi.randClientSkuCode().then(res => {
        this.skuCode = res.data
        this.copy(res.data)
        localStorage.setItem('skuCode', res.data)
      })
    },
    //设置默认值
    setDefaultValue() {
      localStorage.setItem('product_user_id', this.datas.user_id)

    },
  }
}
</script>
<style lang='scss' scoped>
/deep/.el-checkbox__inner {
  transform: scale(1.5) !important;
}

.operation {
  display: flex;
  justify-content: space-between;

  .search {
    display: flex;

    .item {
      width: 180px;
      margin-right: 12px;
    }

    .mash {
      margin-left: 30px;

      i {
        font-size: 20px;
        margin-left: 10px;
        cursor: pointer;
      }
    }
  }
}

.table {
  margin-top: 16px;

  ol {
    height: 56px;
    background: #EDEFF4;
    border-radius: 4px;
    position: sticky;
    top: 0;
    left: 0;
    z-index: 99;
  }

  ul {
    background-color: #fff;
    min-height: 90px;
    padding: 5px 0;

    a {
      color: #295FCF;
      text-decoration: underline;
    }
  }

  li {
    justify-content: left !important;
    margin: 0 17px;
  }

  .flex05 {
    justify-content: center !important;
    flex: 0.2;
  }

  .flex2 {
    flex: 1.5;
  }
}

/deep/.el-textarea__inner {
  min-height: 80px !important;
}

.EXCELtext {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;

  i {
    font-size: 40px;
    margin-left: 20px;
    color: #B4272D;
  }
}
</style>